module.exports = __webpack_public_path__ + "img/index3.e7299b78.png";